<template>
    <div id="mCenter">
        <div id="headers">
            <i class="arr" @click="goBack()"></i>
            <p class="title">{{title}}</p>
        </div>
        <div class="setFix"></div>
        <div class="content">
            <div class="item" @click="intoList(1)">
                <img src="@/assets/imgs/djjl.png" alt="">
                <p class="name">登记记录</p>
            </div>
            <div class="item item2" @click="intoList(2)">
                <img src="@/assets/imgs/crjl.png" alt="">
                <p class="name">出入记录</p>
            </div>
            <div class="item item3" @click="intoList(3)">
                <img src="@/assets/imgs/zq.png" alt="">
                <p class="name">执勤者管理</p>
            </div>
            <div class="item item4" @click="intoList(4)">
                <img src="@/assets/imgs/zq.png" alt="">
                <p class="name">小区信息</p>
            </div>
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'管理中心'
        }
    },
    methods:{
        intoList(type) {
            if(type==1) {
                this.$router.push({path:`/records?poiId=${this.$route.query.poiId}`})
            }else if(type==2) {
                this.$router.push({path:`/crrecords?poiId=${this.$route.query.poiId}`})
            }else if(type==3) {
                this.$router.push({path:`/zqzmg?poiId=${this.$route.query.poiId}`})
            }else if(type==4) {
                this.$router.push({path:`/areamsg?poiId=${this.$route.query.poiId}`})
            }
        },
        goBack() {
            this.$router.push({path:'/',query:{poiId:this.$route.query.poiId,state:0}})
        },
    },
    destroyed() {
        localStorage.setItem("pass",'')
    },
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    #mCenter{
        .content{
            padding:40px 30px;
            border-top:1px solid #eee;
            .item{
                text-align: center;
                width:47%;
                padding:30px 0;
                margin-bottom: 20px;
                background:#545dff;
                border-radius:10px;
                &.item2{
                    background:#33a9db;
                }
                &.item3{
                    background:#7a54ff;
                }
                &.item4{
                    background:#22bebb;
                }
                .fl();
                &:nth-child(2n) {
                    .fr();
                }
                img{
                    width:40px;
                }
                .name{
                    color:@white;
                    font-weight: bold;
                    margin:10px 0 0 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/mcenter/mcenter.vue